import {
  Column,
  DayType,
  DaysType,
  Item,
  MainFieldType,
  OrderType,
} from './schemas';

export const modelTransitiveDateTypes = [
  'daily',
  'weekly',
  'monthly',
  'any',
] as const;
export type ModelTransitiveDateType = (typeof modelTransitiveDateTypes)[number];

export const isModelTransitiveDateType = (
  value: unknown
): value is ModelTransitiveDateType =>
  typeof value === 'string' &&
  modelTransitiveDateTypes.some((dateType) => dateType === value);

export type DataModelTransitionParams = {
  mainField?: MainFieldType;
  transitiveFields?: string[];
  nonTransitiveFields?: string[];
  marking?: string;
  areas?: string[];
  halls?: string[];
  dateType?: ModelTransitiveDateType;
  durationForAnyDateType?: number;
  startDate?: string;
  endDate?: string;
  excludeToday?: boolean;
  days?: DaysType[];
  dayType?: DayType;
  dateSuffixes?: number[];
  dates?: number[];
  kiList?: string[];
  /** SISタイプ別出力では行の識別子も兼ねる（検索条件のタイプ絞込と同じ param 名） */
  sisTypes?: string[];
  tagIds?: string[];
  shuGroupIds?: string[];
  shuList?: string[];
  shuGroupIdsForSijiritu?: string[];
  kiListForSijiritu?: string[];
  /** SISタイプ別の支持率分母。検索のタイプ絞込。未絞込なら省略 */
  sisTypesForSijiritu?: string[];
  /**
   * SISタイプ別店舗展開の起点。文字列（`type`）。配列不可。
   * 組み立て後の mainField は hlMei になるため、BE がタイプ起点と判別するために載せる。
   */
  parentMainField?: MainFieldType;
  sortForHeader?: string;
  sortForTransitiveField?: string;
  order?: OrderType;
  isFiltering?: boolean;
};

export type DataModelTransitionData = {
  columnsForNonTransition: Column[];
  columnsForTransition: Column[];
  dates: {
    name: string;
    code: string;
    backgroundColor: string | null;
  }[];
  rows: {
    queryParameter: {
      kiList?: string[];
      sisTypes?: string[];
      tagIds?: string[];
      halls: string[];
    };
    dataForNonTransition: Item[];
    dataForTransition: Item[][];
  }[];
};

export type DataModelTransition = {
  setting: Required<DataModelTransitionParams>;
  data: DataModelTransitionData;
};
